/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface PageMetadata
 */
export interface PageMetadata  {
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the PageMetadata interface.
 */
export function instanceOfPageMetadata(value: object): value is PageMetadata {
    return true;
}

export function PageMetadataFromJSON(json: any): PageMetadata {
    return PageMetadataFromJSONTyped(json, false);
}

export function PageMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageMetadata {
    if (json == null) {
        return json;
    }
    return {
        
                  'size': json['size'] == null ? undefined : json['size'],
                  'number': json['number'] == null ? undefined : json['number'],
                  'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
                  'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}

export function PageMetadataToJSON(json: any): PageMetadata {
    return PageMetadataToJSONTyped(json, false);
}

export function PageMetadataToJSONTyped(value?: PageMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'size': value['size'],
        'number': value['number'],
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}


